import { render } from "./SkeletonCard.vue?vue&type=template&id=70fddc6a&scoped=true"
import script from "./SkeletonCard.vue?vue&type=script&lang=js"
export * from "./SkeletonCard.vue?vue&type=script&lang=js"

import "./SkeletonCard.vue?vue&type=style&index=0&id=70fddc6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fddc6a"]])

export default __exports__